import styled from "styled-components";
import { inputCheckboxIndex } from "../../../../config/zIndex";

export const AppsDiv = styled.div`
  width: 100%;
  max-width: 860px;
  margin: 10px 0;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const TitleTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const DataDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: ${({ justifyContent }) => (justifyContent ? "flex-start" : "center")};
  flex-wrap: wrap;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
export const InputPositioner = styled.div`
  padding-right: 135px;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 910px) {
    padding: 0;
    width: 150px;
  }
`;
export const InputDataDiv = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
`;
export const AppImg = styled.img`
  margin: 0 15px;
  width: 20px;
  height: 20px;
`;
export const InputCheckboxDiv = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
`;
export const InputCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  z-index: ${inputCheckboxIndex};
`;
export const VerifyCheckboxImg = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
`;
